import type { Messages } from "../types";

export const no = {
  "common": {
    "brand": "UN8",
    "brandTag": "Eksklusiv kristen dating",
    "continue": "Fortsett",
    "leave": "Forlat",
    "leaveForNow": "Forlat for nå",
    "yes": "Ja",
    "no": "Nei",
    "goBack": "Gå tilbake",
    "saving": "Lagrer…",
    "submitting": "Sender…",
    "pleaseWait": "Vent litt…",
    "ellipsis": "…",
    "male": "Mann",
    "female": "Kvinne",
    "phases": {
      "gate": "Port",
      "verify": "Verifiser",
      "setup": "Oppsett",
      "profile": "Profil"
    },
    "storageQuota": "Denne telefonen er tom for plass til lagrede svar. Frigjør lagring, og prøv igjen.",
    "storageDisabled": "Denne nettleseren lagrer ikke svarene dine. Slå av privat modus, eller tillat nettstedsdata, og last inn på nytt.",
    "charMeta": "{len}/{min} min · {current}/{max}",
    "charMetaMin": "min {min} tegn"
  },
  "welcome": {
    "promise": "Målet vårt er at du sletter denne appen så raskt som mulig.",
    "sub": "UN8 hjelper seriøse kristne singler med å finne en livspartner — og deretter forlate. Verifisert. Verdier først. Ingen endeløs swiping.",
    "signedInAs": "Innlogget som {email}",
    "liveServer": " · live-server",
    "deviceOnly": " · bare denne enheten",
    "migrateOffer": "Denne enheten har fortsatt en lokal profil. Laste den opp til den delte serveren slik at andre telefoner kan se deg etter moderering? Ingenting lastes opp før du velger.",
    "uploadLocalProfile": "Last opp min lokale profil",
    "keepOnDevice": "Behold den bare på denne enheten",
    "migrateNeedGender": "Velg først Mann eller Kvinne i profilen din.",
    "migrateDone": "Profiltekst lastet opp. Last opp ID, video og bilder på nytt slik at moderering kan vurdere dem.",
    "deleteConfirm": "Slette kontoen din, alle meldinger og all media (inkludert ID og video) permanent fra serveren?",
    "accountDeleted": "Konto slettet.",
    "begin": "Begynn",
    "continueOnboarding": "Fortsett onboarding",
    "logIn": "Logg inn",
    "logOut": "Logg ut",
    "reviewConsole": "Vurderingskonsoll",
    "matching": "Matching",
    "deleteMyAccount": "Slett kontoen min"
  },
  "faith": {
    "eyebrow": "Trosport",
    "title": "Bare kristne",
    "text": "UN8 er et fellesskap av etterfølgere av Jesus Kristus, for medlemmer som søker en ekteskapsrettet partner som deler den troen. Denne porten kan ikke hoppes over.",
    "yesTitle": "Jeg er kristen",
    "yesBody": "Jeg følger Jesus Kristus og søker en ekteskapsrettet partner som deler denne troen.",
    "noTitle": "Jeg er ikke kristen",
    "noBody": "UN8 er ikke det rette stedet for meg — og det er greit.",
    "respectTitle": "Med respekt",
    "respectBody": "UN8 er bygget for ett fellesskap, og vi vil heller være ærlige enn å kaste bort tiden din. Bruk Forlat nedenfor, eller Tilbake, hvis dette ikke er hjemmet ditt.",
    "sharedTitle": "Delt fundament",
    "sharedBody": "Tro er ikke en etikett her. Det er grunnen dere møtes på.",
    "hintNotChristian": "UN8 er for etterfølgere av Jesus Kristus. Trykk Forlat nedenfor, eller velg det kristne alternativet hvis det er deg.",
    "hintUnset": "Trykk «Jeg er kristen» for å fortsette, eller Forlat / Tilbake hvis dette ikke er hjemmet ditt."
  },
  "rules": {
    "eyebrow": "Fellesskapets pakt",
    "title": "Hvordan vi behandler hverandre",
    "text": "Bekreft hver regel. Alle tre er påkrevd. Brudd fører til permanent fjerning. Falske profiler utestenges for alltid.",
    "agreeContinue": "Jeg godtar — fortsett",
    "respectful": {
      "title": "Vær respektfull",
      "description": "Snakk og handle med verdighet. Hver person her er skapt i Guds bilde."
    },
    "noSexualContent": {
      "title": "Ikke seksuelt innhold",
      "description": "Ingen eksplisitte bilder, meldinger eller forespørsler. Renhet er ikke valgfritt her."
    },
    "noDominance": {
      "title": "Ikke dominer eller kontroller",
      "description": "Ingen tvang, manipulering eller press. Kjærlighet kontrollerer ikke."
    },
    "hint": "Kryss av alle tre løftene før du fortsetter."
  },
  "intent": {
    "eyebrow": "",
    "title": "Hva ser du etter?",
    "text": "",
    "marriage": {
      "label": "En livspartner",
      "description": ""
    },
    "discernment": {
      "label": "Alvorlig dømmekraft",
      "description": ""
    },
    "notCasual": {
      "label": "Ingenting tilfeldig",
      "description": ""
    },
    "hint": "Velg én."
  },
  "account": {
    "eyebrow": "Konto",
    "title": "Opprett tilgangen din",
    "text": "Handle-en din oppretter en stabil bruker-id. Søknad, verifisering, likes og matcher binder alle til den id-en. Ingen e-post sendes.",
    "recoveryTitle": "Lagre gjenopprettingskoden din",
    "recoveryText": "Vises én gang. Uten den kan en mistet passordfrase ikke tilbakestilles i denne lukkede testen.",
    "savedContinue": "Jeg har lagret den — fortsett",
    "handle": "Handle",
    "handlePlaceholder": "du@eksempel.com eller et kort handle",
    "passphrase": "Passordfrase",
    "passphrasePlaceholder": "Minst 8 tegn",
    "signedInTitle": "Innlogget",
    "signedInBody": "{email} · {userId}",
    "trustTitle": "Tillitsstandard",
    "trustBody": "Ingen profil er synlig før identitetsverifisering er fullført og moderering godkjenner deg.",
    "continueToVerification": "Fortsett til verifisering",
    "hintEmail": "Skriv en e-postadresse som inneholder @.",
    "hintPassword": "Velg et passord med minst 8 tegn."
  },
  "verify": {
    "intro": {
      "eyebrow": "Verifisering",
      "title": "Tillit er porten",
      "text": "Last opp et offentlig ID, en bekreftelsesvideo og {min}–{max} ekte bilder. Alt går inn i en vurderingskø før profilen din kan vises.",
      "whyTitle": "Hvorfor vi verifiserer",
      "whyBody": "Catfishing og halvannet sannheter har ingen plass her. Falske profiler utestenges permanent. Media lagres med status pending_review til den er godkjent.",
      "start": "Start verifisering"
    },
    "steps": {
      "id": {
        "title": "Offentlig ID",
        "description": "Pass eller nasjonalt ID — kamera eller filopplasting."
      },
      "video": {
        "title": "Bekreftelsesvideo",
        "description": "En kort opptak som beviser at du er til stede."
      },
      "photos": {
        "title": "Ekte bilder",
        "description": "Syv til ti tydelige bilder av deg selv."
      },
      "review": {
        "title": "Integritetsvurdering",
        "description": "Opplastinger forblir pending_review til ansatte bekrefter."
      }
    },
    "id": {
      "eyebrow": "Steg 1 av 4",
      "title": "Offentlig ID",
      "text": "Ta eller last opp passet eller nasjonale ID-et ditt. Ingenting postes offentlig — status forblir pending_review til ansatte bekrefter.",
      "savedTitle": "ID lagret",
      "savedBody": "Neste er en kort bekreftelsesvideo av ansiktet ditt, deretter 7 til 10 ekte bilder av deg selv. Fortsett låses opp når denne ID-en viser lagret.",
      "hint": "Ta eller last opp et bilde av offentlig ID, og vent til det står lagret."
    },
    "video": {
      "eyebrow": "Steg 2 av 4",
      "title": "Bekreftelsesvideo",
      "text": "Ta opp et kort klipp eller last opp ett. Se inn i kameraet. Snakk tydelig. Dette beviser at du er til stede — ikke et skrapet galleri.",
      "hint": "Ta opp en kort bekreftelsesvideo, og vent til det står lagret."
    },
    "photos": {
      "eyebrow": "Steg 3 av 4",
      "title": "Ekte bilder",
      "text": "Legg til {min}–10 nyere bilder av deg selv. Bruk kameraet eller biblioteket ditt. Trykk × for å fjerne et bilde.",
      "continueToReview": "Fortsett til vurdering",
      "hint": "Legg til {min} til 10 tydelige bilder av deg selv. Fortsett låses opp når de er lagret."
    },
    "review": {
      "eyebrow": "Steg 4 av 4",
      "title": "Integritetsvurdering",
      "text": "Media er køet som pending_review{underUser}. Matcher og likes bruker samme id.",
      "underUser": " under bruker {userId}",
      "governmentId": "Offentlig ID",
      "confirmationVideo": "Bekreftelsesvideo",
      "photos": "Bilder",
      "missing": "Mangler",
      "filesReady": "{count} filer klare",
      "submittedTitle": "Sendt til vurdering",
      "submittedText": "Søknads-id er lik auth-bruker-id slik at godkjenning → pool og gjensidige likes forblir på linje.",
      "submitContinue": "Send & fortsett"
    }
  },
  "setup": {
    "eyebrow": "Kontooppsett",
    "title": "Fortell sannheten om deg selv",
    "text": "Disse svarene former matching og vises i vurdering. Myke løgner kaster bort alles tid — inkludert din.",
    "beginSetup": "Begynn oppsett",
    "pillars": {
      "faith": {
        "name": "Tro",
        "text": "Hvorfor du følger Kristus."
      },
      "character": {
        "name": "Karakter",
        "text": "Lojalitet, ærlighet, lidenskap, forpliktelse — vurdert 1–10."
      },
      "story": {
        "name": "Historie",
        "text": "Hvem du er og hva du søker."
      },
      "life": {
        "name": "Liv",
        "text": "Hobbyer, lesing og yrke."
      }
    },
    "whyChristian": {
      "eyebrow": "Tro",
      "title": "Hvorfor er du kristen?",
      "text": "Et kort, ærlig svar. Ikke en preken — en grunn som er din.",
      "label": "Ditt svar",
      "placeholder": "f.eks. Jeg møtte Kristus i en tid med tap og har fulgt Ham siden…",
      "hint": "Skriv minst {min} tegn om hvorfor du følger Jesus."
    }
  },
  "scales": {
    "eyebrow": "Karakterskalaer",
    "title": "Vurder deg selv ærlig",
    "text": "Lojalitet, ærlighet, lidenskap, forpliktelse — hver fra 1 til 10. Oppblåste tall mismatchet deg bare senere. Du må sette hver skala for å fortsette.",
    "loyalty": {
      "label": "Nivå av lojalitet",
      "hint": "Vær ærlig — hvor trofast står du ved dem du elsker?"
    },
    "honesty": {
      "label": "Nivå av ærlighet",
      "hint": "Hvor konsekvent forteller du den fulle sannheten?"
    },
    "passion": {
      "label": "Hvor lidenskapelig er du?",
      "hint": "Overbevisning og dybde — ikke opptreden."
    },
    "commitment": {
      "label": "Nivå av forpliktelse",
      "hint": "Hvor klar er du til å bygge noe som varer?"
    },
    "hint": "Flytt hver glidebryter slik at et tall vises — ingen kan stå som en strek."
  },
  "about": {
    "eyebrow": "Om deg",
    "title": "Beskriv deg selv i noen setninger",
    "text": "Hvem du er når ingen opptrer. Temperament, rytme, hva som betyr noe dag for dag.",
    "label": "Om deg",
    "placeholder": "Stille morgener, seriøs om familie, ler lett, foretrekker dybde fremfor støy…",
    "hint": "Skriv minst {min} tegn om deg selv."
  },
  "looking": {
    "eyebrow": "Partner",
    "title": "Hva ser du etter?",
    "text": "Hovedkaraktertrekk du ønsker hos en potensiell partner — ikke en handleliste over utseende.",
    "label": "Ønskede karaktertrekk",
    "placeholder": "f.eks. Standhaftig tro, emosjonell modenhet, vennlighet under stress…",
    "hint": "Skriv minst {min} tegn om partneren du håper på."
  },
  "loveReady": {
    "eyebrow": "Terskel",
    "title": "Er du klar til å møte kjærligheten i livet ditt?",
    "text": "UN8 finnes slik at seriøse singler finner en partner — og deretter sletter appen. Bare «Ja» låser opp fortsett.",
    "yesTitle": "Ja — jeg er klar",
    "yesBody": "Jeg er her for å møte personen min med klarhet og mot.",
    "noTitle": "Ikke ennå",
    "noBody": "Hvis du bare blar, passer ikke dette fellesskapet.",
    "comeBackTitle": "Kom tilbake når du er klar",
    "comeBackBody": "UN8 er for folk som er forberedt på å møte — ikke å samle alternativer. Bruk Forlat nedenfor hvis du vil stoppe for nå. Svarene dine er lagret på denne telefonen.",
    "hintNo": "Bare «Ja» fortsetter. Hvis du ikke er klar, trykk Forlat for nå — svarene dine blir på denne telefonen.",
    "hintUnset": "Trykk Ja hvis du er klar til å møte noen med ekteskap for øye."
  },
  "lifestyle": {
    "eyebrow": "Livsstil",
    "title": "Hvordan du lever dag for dag",
    "text": "Sport, hobbyer, lesing og yrke — praktiske signaler for reell kompatibilitet.",
    "hobbies": "Nåværende sport eller hobbyer",
    "hobbiesPlaceholder": "Det du aktivt gjør — ikke det du gjorde en gang.",
    "reading": "Leser du?",
    "readingHint": "1 = nesten aldri · 10 = daglig, dyp lesing",
    "profession": "Yrke / sektor",
    "professionPlaceholder": "f.eks. Sykepleie · Programvare · Utdanning · Håndverk",
    "hintHobbies": "Nevn minst én sport eller hobby du faktisk gjør.",
    "hintReading": "Skyv «Leser du?» slik at et tall fra 1 til 10 vises.",
    "hintProfession": "Skriv arbeidet du gjør, selv et kort ord."
  },
  "faithDepth": {
    "eyebrow": "Matching · Tro",
    "title": "Hvor sentral er troen din?",
    "text": "Å tjene Gud — hvor viktig i livet ditt? Svar ærlig. Matching bruker dette for dybde, ikke opptreden.",
    "serving": "Å tjene Gud — betydning",
    "servingHint": "10% … 100%. Skyv i steg på 10.",
    "keepsCommandments": "Holder du budene?",
    "grewUpInChurch": "Vokste du opp i kirken?",
    "churchAttendance": "Kirkegang",
    "frequent": {
      "label": "Ofte",
      "hint": "Regelmessig samling med Kristi legeme."
    },
    "seldom": {
      "label": "Sjelden",
      "hint": "Av og til, ikke en ukentlig rytme."
    },
    "never": {
      "label": "Aldri",
      "hint": "Deltar ikke for tiden."
    },
    "spreadsGospel": "Sprer du evangeliet?",
    "hasIdols": "Har du avguder?",
    "hintServing": "Skyv hvor viktig det er å tjene Gud i livet ditt.",
    "hintCommandments": "Svar om du holder budene — Ja eller Nei.",
    "hintGrewUp": "Svar om du vokste opp i kirken — Ja eller Nei.",
    "hintAttendance": "Velg hvor ofte du går i kirken.",
    "hintGospel": "Svar om du deler evangeliet — Ja eller Nei.",
    "hintIdols": "Svar om du har avguder — Ja eller Nei."
  },
  "character": {
    "eyebrow": "Matching · Karakter",
    "title": "Hvem du er hjemme",
    "text": "Karakter for frieri — fredsskaping, manerer, ærlighet. Oppblåste svar mismatchet deg bare senere.",
    "peacemaker": "Er du en fredsskaper?",
    "homebuilder": "Er du en hjemmebygger?",
    "humorous": "Er du humoristisk?",
    "caring": "Omsorgsfull og kjærlig?",
    "peacefulHome": "Vil du ha et fredelig hjem — uten krangling?",
    "manners": "Gode manerer?",
    "honestyRating": "Ærlighetsvurdering på dette skjemaet",
    "honestyHint": "1–10 — hvor ærlig svarer du?",
    "hintPeacemaker": "Svar Ja eller Nei på hver, start med fredsskaper.",
    "hintHomebuilder": "Svar om du er en hjemmebygger.",
    "hintHumorous": "Svar om du er humoristisk.",
    "hintCaring": "Svar om du er omsorgsfull og kjærlig.",
    "hintPeaceful": "Svar om du vil ha et fredelig hjem.",
    "hintManners": "Svar om du har gode manerer.",
    "hintHonesty": "Skyv ærlighetsvurderingen din fra 1 til 10."
  },
  "history": {
    "eyebrow": "Matching · Historie",
    "title": "Fortid og beredskap",
    "text": "Rusmidler, barndom, arr, og om du er klar for et varig forhold. Sannhet her beskytter dere begge.",
    "marijuana": "Har du brukt marijuana?",
    "lsd": "Har du brukt LSD?",
    "otherDrugs": "Har du brukt andre stoffer?",
    "addicted": "Har du vært avhengig?",
    "childhood": "Stabil, kjærlig barndom?",
    "scars": "Arr / skadet?",
    "lasting": "Klar for et varig forhold?",
    "hintStart": "Svar Ja eller Nei på hver på denne siden, start øverst.",
    "hintLsd": "Svar på LSD-spørsmålet — Ja eller Nei.",
    "hintOtherDrugs": "Svar om du har brukt andre stoffer.",
    "hintAddicted": "Svar om du har vært avhengig.",
    "hintChildhood": "Svar om barndommen din var stabil og kjærlig.",
    "hintScars": "Svar om du bærer arr.",
    "hintLasting": "Svar om du er klar for et varig forhold."
  },
  "appearance": {
    "eyebrow": "Matching · Utseende",
    "title": "Tatoveringer",
    "text": "Tatoveringene dine, og om tatoveringer på en partner er akseptabelt for deg.",
    "hasTattoos": "Har du tatoveringer?",
    "acceptsPartner": "Akseptere tatoveringer på en partner?",
    "hintHas": "Si om du har tatoveringer — Ja eller Nei.",
    "hintAccepts": "Si om tatoveringer på en partner er akseptabelt for deg."
  },
  "home": {
    "eyebrow": "Matching · Hjem & land",
    "title": "Land, ferdigheter, selvforsyning",
    "text": "Urter, dyrke mat, fruktskog, preppring, fellesskapsjordbruk, konservering, overlevelse — og eventuelle spesielle ferdigheter.",
    "herbKnowledge": "Urtekunnskap?",
    "plantOwn": "Dyrker du egen frukt og grønnsaker?",
    "fruitForest": "Interessert i en fruktskog?",
    "prepping": "Forbereder du for katastrofer?",
    "communityFarming": "Fellesskapsjordbruk / uavhengig liv?",
    "canning": "Sylting og konservering?",
    "survival": "Overlevelsesferdigheter?",
    "specialSkills": "Spesielle ferdigheter (valgfritt)",
    "specialPlaceholder": "Alt annet du bringer til et hushold eller land…",
    "hintStart": "Svar Ja eller Nei på hver om land og ferdigheter, start øverst.",
    "hintPlant": "Svar om du dyrker egen frukt og grønnsaker.",
    "hintFruitForest": "Svar om en fruktskog interesserer deg.",
    "hintPrepping": "Svar om du forbereder deg for katastrofer.",
    "hintCommunity": "Svar om fellesskapsjordbruk interesserer deg.",
    "hintCanning": "Svar om du sylter og konserverer mat.",
    "hintSurvival": "Svar om du har overlevelsesferdigheter."
  },
  "family": {
    "eyebrow": "Matching · Familie",
    "title": "Barn, trosdybde, rusmidler",
    "text": "Hva du trenger hos en partner rundt trosintensitet, barn og tidligere rusmiddelbruk.",
    "children": "Barn",
    "wants": {
      "label": "Vil ha barn",
      "hint": "Å bygge en familie er en del av visjonen."
    },
    "doesNotWant": {
      "label": "Vil ikke ha barn",
      "hint": "Klar nei til barn."
    },
    "open": {
      "label": "Åpen",
      "hint": "Skjelner — ikke låst noen vei."
    },
    "hasLivingWith": {
      "label": "Har barn — bor med dem",
      "hint": "Barn er allerede en del av dagliglivet."
    },
    "requiredFaith": "Minimum trosnivå du trenger hos en partner",
    "requiredFaithHint": "10% … 100%. Hard port når begge sider har svart.",
    "acceptsSubstances": "Akseptere tidligere rusmiddelbruk hos en partner?",
    "hintChildren": "Velg ett kort om barn.",
    "hintFaith": "Skyv minimum trosnivå du håper på hos en partner.",
    "hintSubstances": "Si om tidligere rusmiddelbruk hos en partner er akseptabelt."
  },
  "ancestry": {
    "eyebrow": "Matching · Bakgrunn",
    "title": "Bakgrunnspreferanser",
    "text": "Del bakgrunnen din og hva du er åpen for hos en partner. Dette former bare rangering — det skjuler aldri noen fra decket.",
    "yourBackground": "Din bakgrunn (velg alle som gjelder)",
    "openToPartner": "Åpen for hos en partner",
    "codeDesc": "Kode: {code}",
    "anyDesc": "Sterkeste preferanse for bredde — anbefales ved usikkerhet.",
    "preferenceOnly": "Bare preferanse — ikke en port.",
    "hintOwn": "Kryss av minst én bakgrunn som beskriver deg. Dette hjelper bare rangering — det skjuler aldri noen.",
    "hintAccepted": "Kryss av hva du er åpen for hos en partner, eller «Åpen — ingen preferanse»."
  },
  "interests": {
    "eyebrow": "Matching · Interesser",
    "title": "Det du liker",
    "text": "Velg minst én. Overlapp hjelper rangering; stillhet straffes aldri.",
    "hint": "Kryss av minst én interesse."
  },
  "reflection": {
    "eyebrow": "Matching · Refleksjon",
    "title": "Med egne ord",
    "text": "Disse fire svarene vises i sin helhet og scores aldri. Skriv det som er sant.",
    "describeYourself": "Beskriv deg selv",
    "lifePurpose": "Livsformål",
    "fifteenYear": "Du og kjærligheten i livet ditt om 15 år",
    "weaknesses": "Svakheter",
    "hintDescribe": "Beskriv deg selv med minst {min} tegn.",
    "hintPurpose": "Skriv livsformålet ditt med minst {min} tegn.",
    "hintVision": "Skriv 15-årsvisjonen med minst {min} tegn.",
    "hintWeaknesses": "Nevn en svakhet med minst {min} tegn."
  },
  "profile": {
    "eyebrow": "Profil",
    "title": "Noen essentials",
    "text": "Hold det enkelt. Kjønn er binært her — mann eller kvinne — for klar matching.",
    "firstName": "Fornavn",
    "firstNamePlaceholder": "Som du ønsker å bli kjent",
    "age": "Alder",
    "agePlaceholder": "18+",
    "city": "By",
    "cityPlaceholder": "Hvor du er basert",
    "sex": "Kjønn",
    "maleBody": "Jeg er en mann.",
    "femaleBody": "Jeg er en kvinne.",
    "hintName": "Skriv fornavnet ditt (minst to bokstaver).",
    "hintAge": "Alder må være 18 eller eldre.",
    "hintCity": "Skriv byen der du bor.",
    "hintGender": "Velg Mann eller Kvinne slik at matching kan fungere."
  },
  "ready": {
    "title": "Du kan tre inn.",
    "textNamed": "{name}, verifiseringen og oppsettet ditt er registrert. Media er pending_review. Velkommen til UN8 — finn personen din, slett deretter appen.",
    "text": "Verifiseringen og oppsettet ditt er registrert. Media er pending_review. Velkommen til UN8 — finn personen din, slett deretter appen.",
    "summaryAria": "Oppsettssammendrag",
    "christianRules": "Kristen · regler bekreftet",
    "mediaLine": "ID · video · {photoCount} bilder · kø {pending}",
    "scalesLine": "Skalaer L{loyalty}/H{honesty}/P{passion}/C{commitment}",
    "genderProfession": "{gender} · {profession}",
    "sexUnset": "Kjønn —",
    "professionFallback": "yrke",
    "userLine": "Bruker {userId}",
    "enterMatching": "Gå til matching",
    "needGender": "Gå tilbake til profilsteget og velg Mann eller Kvinne, prøv deretter igjen."
  },
  "match": {
    "brandTag": "Matching",
    "navOnboarding": "Onboarding",
    "navReview": "Vurdering",
    "navMatching": "Matching",
    "logOut": "Logg ut",
    "enterTitle": "Gå til matching",
    "enterText": "Logg inn med samme e-post som fra onboarding. Søknad, pool, likes og matcher bruker alle den stabile bruker-id-en din.",
    "email": "E-post",
    "emailPlaceholder": "du@eksempel.com",
    "password": "Passord",
    "passwordPlaceholder": "Passordet ditt",
    "logIn": "Logg inn",
    "guestOr": "Eller prøv en gjestesession (stabil id per nettleser · kun demo)",
    "guestMan": "Gjest som mann",
    "guestWoman": "Gjest som kvinne",
    "goOnboarding": "Gå til onboarding →",
    "guestSession": "Gjestesession · demopool",
    "packTitle": "Dine fire",
    "packSkip": "Trykk for å fortsette",
    "newSelection": "Nytt utvalg",
    "backToFour": "← Tilbake til dine fire",
    "whoLikedTitle": "Who liked you",
    "whoLikedLocked": "Subscribe to see names on the weekly deck — inbound hearts still show on Messages.",
    "whoLikedEmpty": "No one new has liked you yet.",
    "man": "mann",
    "woman": "kvinne",
    "navSelection": "Utvalg",
    "navMessages": "Meldinger",
    "navProfile": "Profil",
    "tabToday": "Utvalg",
    "tabMatches": "Matcher ({count})",
    "yourMatches": "Dine matcher",
    "matchesSub": "Vedvarende gjensidig interesse · {count} utgående {likesWord}",
    "like": "like",
    "likes": "likes",
    "emptyMatches": "Ingen gjensidig interesse ennå. Fortsett å skjelne ukens utvalg.",
    "valuesScore": "Verdier {score}",
    "chatOpen": " · Chat åpen",
    "tapToChat": " · Trykk for å chatte",
    "personLine": "{name}, {age}",
    "cityValues": "{city} · Verdier {score}",
    "noProfileYet": "Ingen profil ennå",
    "noProfileText": "Fullfør onboarding, eller trykk Onboarding øverst og deretter Begynn. Gjestematching er på startskjermen hvis du bare vil se.",
    "matchingPaused": "Matching pauset",
    "moderationDemoNote": "Showing demo people so you can try matching while you wait.",
    "noOneYet": "Ingen å vise ennå",
    "todaysSetDone": "Det er ukens utvalg",
    "weeklyTitle": "Dine 4 denne uken",
    "weeklyTitleCount": "Dine {count} denne uken",
    "weeklyCountdown": "Neste utvalg om {days} dager",
    "weeklyCountdownOne": "Neste utvalg om 1 dag",
    "weeklyCountdownSoon": "Neste utvalg snart",
    "shortWeekCopy": "This week there are {count}. We never suggest someone who is not a fit.",
    "shortWeekTwo": "This week there are two. We never suggest someone who is not a fit.",
    "weekDone": "Det er ukens utvalg",
    "weekDoneText": "You have discerned everyone we could honestly suggest. Come back when the next selection opens.",
    "emptyNeverHad": "Det er ingen på listen denne uken ennå. Poolen fylles — åpne Utvalg igjen om et øyeblikk, eller kom tilbake når flere medlemmer er godkjent.",
    "emptyDone": "Du har gått gjennom ukens utvalg. Kom tilbake ved neste åpning, eller tilbakestill bunken.",
    "likesMayNotStick": " Likes kan kanskje ikke feste seg.",
    "poolMeta": "Pool: {pool} · Matcher: {matches} · Liket: {liked}",
    "demoPool": "demo",
    "livePool": "{source} ({count})",
    "resetDeck": "Tilbakestill deck",
    "backOnboarding": "Tilbake til onboarding",
    "feedEyebrowDemo": "Ukentlig utvalg · Demo",
    "feedEyebrowLive": "Ukentlig utvalg · Pool ({source}, {count})",
    "feedTitle": "Skjelne med omsorg",
    "left": "{count} igjen",
    "pass": "Pass",
    "interested": "Interessert",
    "swipeHint": "Swipe eller bruk knappene. En match åpnes bare når interessen er gjensidig og lagret.",
    "celebrationEyebrow": "Gjensidig interesse",
    "celebrationTitle": "Dere matchte",
    "celebrationText": "{self} og {other} viste begge interesse. Verdialignment: {score}.",
    "celebrationWhyLabel": "Why you matched",
    "celebrationNote": "Chat er låst opp for denne matchen. Hold det respektfullt — pakt over bekvemmelighet.",
    "openChat": "Åpne chat",
    "keepDiscerning": "Fortsett å skjelne",
    "cardSeeking": "Søker",
    "cardHobbies": "Hobbyer",
    "affinity": "Affinitet",
    "valuesScoreLabel": "Verdiscore",
    "scoreStrong": "Sterk alignment",
    "scoreSolid": "Solid alignment",
    "scoreModerate": "Moderat alignment",
    "scoreDifferent": "Ulike rytmer",
    "characterAxisFoot": "Karakteraksen inkluderer de fire pilarene",
    "youThem": "Du {self} · De {other}",
    "stampInterest": "Interesse",
    "stampPass": "Pass",
    "explainLikedYou": "They already liked you — this is mutual interest waiting to happen.",
    "explainLegacyClose": "Verdiscorene deres ligger tett ({score} av 100).",
    "explainLegacyFuller": "En fyldigere «hvorfor» vises etter at dere begge har fullført matchingsspørsmålene.",
    "explainFaith": "Trosintensiteten deres ligger nær — dere tar etterfølgelse av Jesus med lignende alvor.",
    "explainCharacter": "Hvordan dere behandler folk hjemme stemmer — fred, manerer og omsorg.",
    "explainPurpose": "Dere vurderte egen ærlighet lignende, et tegn på delt alvor.",
    "explainHome": "Dere deler interesse for land, dyrking eller et selvforsynt hjem.",
    "explainAncestry": "Dere begge foretrekker lignende familiebakgrunner. Det er en preferanse, ikke et filter — ingen skjules for det.",
    "explainTemperament": "Interessene og temperamentet deres overlapper.",
    "explainFallback": "Det er en mulig match på svarene dere begge fylte ut.",
    "explainOverall": "Samlet affinitet {score} av 100.",
    "affinityAxes": {
      "faith": "Trosintensitet",
      "character": "Karakter & oppførsel",
      "purpose": "Livsformålsalignment",
      "home": "Hjem & selvforsyning",
      "ancestry": "Kulturell & bakgrunnsaffinitet",
      "temperament": "Temperamentspassform"
    },
    "scaleAxes": {
      "loyalty": "Lojalitet",
      "honesty": "Ærlighet",
      "passion": "Lidenskap",
      "commitment": "Forpliktelse"
    },
    "verify": {
      "brandTag": "Verify",
      "title": "Verify to message",
      "sub": "Anyone can browse and heart. A conversation needs your ID and a short confirmation video. Submitted is enough — review can wait.",
      "cta": "Add ID and video",
      "videoCta": "Add a confirmation video",
      "submitted": "ID and video are in. You can message while we review.",
      "done": "You’re verified.",
      "back": "Back",
      "continue": "Continue",
      "idEyebrow": "Identity",
      "videoEyebrow": "Presence",
      "idText": "Passport or national ID. Nothing is posted publicly. Submitted is enough to talk.",
      "videoText": "A short clip (about {seconds} seconds). Face the camera. This proves you are present."
    }
  },
  "chat": {
    "brandTag": "Chat",
    "unavailableTitle": "Chat utilgjengelig",
    "unavailableText": "Denne matchen mangler eller tilhører ikke økten din.",
    "backToMatches": "Tilbake til matcher",
    "backMatches": "← Matcher",
    "valuesSubscriber": "Verdier {score} · Abonnent",
    "valuesTrial": "Verdier {score} · Prøveperiode",
    "valuesKept": "Verdier {score} · Match beholdt",
    "empty": "Si hei med omsorg. På den delte backend synkroniseres meldinger til begge telefoner etter en gjensidig match.",
    "placeholder": "Melding til {name}…",
    "ariaMessage": "Melding",
    "send": "Send"
  },
  "billing": {
    "paywallCopy": "Etter gratis prøveperiode beholder du alle du allerede har matcht med og kan fortsette å chatte. For å se nye mennesker, abonner.",
    "signInToMatch": "Logg inn for å bruke matching.",
    "signInFirst": "Logg inn først.",
    "subscriberUntil": "Abonnent · til {date}",
    "renewal": "fornyelse",
    "freeTrial": "Gratis prøveperiode · {days} dager (slutter {date})",
    "soon": "snart",
    "trialEnded": "Prøveperiode avsluttet · matcher & chat forblir åpne",
    "subscribe": "Abonner · ${price}/mnd",
    "subscribeEarly": "Abonner tidlig · ${price}/mnd",
    "activeNote": "Abonnement aktivt — du kan se nye mennesker igjen.",
    "playOnly": "Subscription is Google Play Billing only (app install). There is no web checkout here.",
    "playOnlyShort": "Billing via Google Play only — no web payment."
  },
  "auth": {
    "recoveryTitle": "Lagre gjenopprettingskoden din",
    "recoveryText": "Skriv dette ned nå. Det vises én gang. Hvis du mister passordfrasen, er denne koden den eneste måten å tilbakestille den i den lukkede testen.",
    "savedContinue": "Jeg har lagret den — fortsett",
    "welcomeBack": "Velkommen tilbake",
    "createAccount": "Opprett kontoen din",
    "intro": "Handle og passordfrase. Ingen e-post eller SMS sendes. Id-en din forblir stabil over onboarding, vurdering og matching.",
    "tabLogin": "Logg inn",
    "tabRegister": "Registrer",
    "handle": "Handle",
    "handlePlaceholder": "du@eksempel.com eller et kort handle",
    "passphrase": "Passordfrase",
    "passphrasePlaceholder": "Minst 8 tegn",
    "submitLogin": "Logg inn",
    "submitRegister": "Opprett konto",
    "backWelcome": "Tilbake til velkomst"
  },
  "options": {
    "origin": {
      "african": "Afrikansk",
      "european": "Europeisk",
      "asian": "Asiatisk",
      "latino": "Latino / Hispanic",
      "middleEastern": "Midtøsten",
      "indigenous": "Urfolk",
      "mixed": "Blandet",
      "other": "Annet",
      "dutch": "Nederlandsk",
      "german": "Tysk",
      "any": "Åpen — ingen preferanse"
    },
    "interest": {
      "prayer": "Bønn",
      "worship": "Tilbedelse",
      "reading": "Lesing",
      "hiking": "Turgåing",
      "music": "Musikk",
      "cooking": "Matlaging",
      "farming": "Jordbruk / hage",
      "sports": "Sport",
      "missions": "Misjon",
      "family": "Familieliv",
      "crafts": "Håndverk",
      "outdoors": "Utendørs"
    }
  },
  "capture": {
    "yesNoDefaults": {
      "yes": "Ja",
      "no": "Nei"
    },
    "id": {
      "titleEmpty": "Offentlig ID",
      "titleReady": "ID klar",
      "hintEmpty": "Pass eller nasjonalt ID. Ta et livebilde, eller velg et bilde/PDF. Alle fire hjørner synlige.",
      "hintReady": "{fileName} · {bytes}{saved}",
      "savedSuffix": " · lagret",
      "previewAlt": "Forhåndsvisning av offentlig ID",
      "pdfAria": "PDF-dokument valgt",
      "takePhoto": "Ta bilde",
      "retake": "Ta på nytt",
      "chooseFile": "Velg fil",
      "replaceFile": "Bytt fil",
      "remove": "Fjern",
      "uploading": "Laster opp…",
      "cameraTitle": "Fotografer ID-en din",
      "signIn": "Logg inn før du laster opp ID.",
      "uploadFailed": "Opplasting mislyktes. Prøv igjen.",
      "badFile": "Kunne ikke bruke denne filen."
    },
    "video": {
      "titleEmpty": "Bekreftelsesvideo",
      "titleLive": "Kamera live",
      "titleReady": "Video klar",
      "hintEmpty": "Si fornavnet ditt og at du blir med i UN8 ærlig. 5–15 sekunder.",
      "hintReady": "{fileName} · {bytes}{saved}",
      "rec": "REC {seconds}s",
      "record": "Ta opp",
      "cameraUpload": "Kameraopplasting",
      "chooseFile": "Velg fil",
      "startRecording": "Start opptak",
      "cancel": "Avbryt",
      "stopSave": "Stopp & lagre",
      "recordAgain": "Ta opp igjen",
      "replaceFile": "Bytt fil",
      "remove": "Fjern",
      "unsupported": "Liveopptak er utilgjengelig her. Bruk kameraopplasting eller velg en fil.",
      "permissionDenied": "Kameratillatelse nektet. Du kan fortsatt laste opp en kort videofil.",
      "signIn": "Logg inn før du laster opp video.",
      "uploadFailed": "Opplasting mislyktes. Prøv igjen.",
      "saveFailed": "Kunne ikke lagre opptaket.",
      "badVideo": "Kunne ikke bruke denne videoen."
    },
    "photos": {
      "count": "{count} / {max} bilder",
      "minimumMet": "Minimum oppfylt",
      "moreRequired": "{n} til kreves",
      "listAria": "Verifiseringsbilder",
      "photoAlt": "Bilde {n}",
      "removeAria": "Fjern bilde {n}",
      "camera": "Kamera",
      "takePhoto": "Ta bilde",
      "chooseFiles": "Velg filer",
      "uploading": "Laster opp…",
      "hint": "Ta bilde åpner livekameraet. Velg filer er bare for gallerivalg. Tydelige ansiktsbilder — ingen filtre som skjuler identitet. Maks {max}.",
      "cameraTitle": "Ta et bilde av deg selv",
      "signIn": "Logg inn før du laster opp bilder.",
      "someFailed": "Noen bilder ble ikke lastet opp. Prøv de mislykkede på nytt.",
      "addFailed": "Kunne ikke legge til bilder."
    },
    "liveStill": {
      "titleDefault": "Kamera",
      "close": "Lukk",
      "capture": "Ta bilde",
      "cancel": "Avbryt",
      "hint": "Hold stødig. Livekameraet forblir åpent til du tar bilde.",
      "unavailable": "Kamera er ikke tilgjengelig i denne nettleseren. Bruk Velg fil i stedet.",
      "permissionDenied": "Kameratillatelse nektet eller utilgjengelig. Bruk Velg fil i stedet.",
      "frameFailed": "Kunne ikke ta dette bildet.",
      "saveFailed": "Kunne ikke lagre bildet."
    },
    "uploadStatus": {
      "uploading": "laster opp…",
      "failed": "opplasting mislyktes",
      "savedLocally": "lagret lokalt",
      "uploaded": "lastet opp",
      "stored": "lagret",
      "awaitingUpload": "Venter på opplasting",
      "localFallbackNote": "{error} Filen er lagret på denne enheten; prøv igjen når sign-endepunktet er oppe."
    }
  },
  "language": {
    "label": "Språk",
    "choose": "Velg språk"
  },
  "shell": {
    "back": "Tilbake",
    "goBackAria": "Gå tilbake"
  }
} as Messages;
